<template>
  <div class="personalReport">
    <div class="title">新建证书<Back /></div>

    <div class="reportInfo">
      <div>
        <div>报告名称：{{ report.name }}</div>
        <div>报告备注：{{ report.remark }}</div>
      </div>
      <!-- <div class="btns">
        <button class="btn_primary" style="margin-right:18px;">查看报告</button
        ><button class="btn_primary_plain">删除报告</button>
      </div> -->
    </div>

    <div class="subTitle">
      电子证书
    </div>
    <el-form label-width="110px" label-position="left" :modal="form">
      <el-form-item label="电子证书名称：">
        <el-input
          style="width:359px"
          v-model="form.name"
          :placeholder="`${etcDefaultName},点击可修改`"
        ></el-input>
      </el-form-item>
      <el-form-item label="授权给：">
        <div>
          <el-radio
            v-model="isLimitUser"
            @change="handleLimitUserChange"
            label="1"
            >不限对象</el-radio
          >
          <el-radio
            v-model="isLimitUser"
            @change="handleLimitUserChange"
            label="2"
            >限制对象</el-radio
          >
        </div>
        <div>
          <el-input
            v-model="phone"
            style="width:359px;"
            placeholder="请输入授权对象手机号，按回车键添加"
            :disabled="isLimitUser === '1'"
            @keyup.enter.native="savePhone"
          ></el-input>
        </div>
        <div class="tagList">
          <div
            class="tagItem"
            v-for="(item, index) in authorizationUsers"
            :key="index"
          >
            {{ item }}
            <i @click="handleDeletePhone(index)" />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="允许查看次数：">
        <div>
          <el-radio
            v-model="isLimitTimes"
            @change="handleLimitTimesChange"
            label="1"
            >不限次数</el-radio
          >
          <el-radio
            v-model="isLimitTimes"
            @change="handleLimitTimesChange"
            label="2"
            >限制次数</el-radio
          >
        </div>
        <div>
          <el-input
            v-model="form.authorizationTimes"
            type="number"
            :min="0"
            style="width:359px;"
            placeholder="请输入限制次数"
            :disabled="isLimitTimes === '1'"
          ></el-input>
        </div>
        <!-- <div style="display: flex;flex-direction: column;">
          <div>
            <el-checkbox
              v-model="checkTimes"
              @change="handleCheckTimesChange($event, 0)"
              >不限次数</el-checkbox
            >
          </div>
          <div>
            <el-checkbox
              v-model="checkTimes1"
              @change="handleCheckTimesChange($event, 1)"
            ></el-checkbox
            ><el-input
              v-model="form.authorizationTimes"
              type="number"
              :min="0"
              style="width:322px;padding-left:17px"
              :disabled="!checkTimes1"
            ></el-input>
          </div>
        </div> -->
      </el-form-item>
      <el-form-item label="授权期限：">
        <div>
          <el-radio
            v-model="isLimitDate"
            @change="handleLimitDateChange"
            label="1"
            >不限时间</el-radio
          >
          <el-radio
            v-model="isLimitDate"
            @change="handleLimitDateChange"
            label="2"
            >限制时间</el-radio
          >
        </div>
        <div>
          有效期至：<el-datePicker
            style="width:289px"
            v-model="form.endDate"
            :picker-options="pickerOptions"
            :disabled="isLimitDate === '1'"
            placeholder="请选择授权截止时间"
            value-format="timestamp"
          ></el-datePicker>
        </div>
        <!-- <div style="display: flex;flex-direction: column;">
          <div>
            <el-checkbox
              v-model="authDateLimit"
              @change="handleAuthDateLimit1Change($event, 0)"
              >不限时间</el-checkbox
            >
          </div>
          <div>
            <el-checkbox
              v-model="authDateLimit1"
              @change="handleAuthDateLimit1Change($event, 1)"
            ></el-checkbox>
            <el-datePicker
              style="width:144px"
              v-model="form.endDate"
              :disabled="!authDateLimit1"
              value-format="timestamp"
            ></el-datePicker>
          </div>
        </div> -->
      </el-form-item>
    </el-form>
    <button class="btn_add" @click="handleCreate">确认新建</button>
    <div v-if="dialagPay">
      <PayMember
        @handleClose="handleDialagPayClose"
        :payType="'ELECTRONIC_CERTIFICATE_SINGLE_PAYMENT'"
        :socket-id="_socketId"
        title="生成电子证书"
      >
        <div slot="coverFooter" style="text-align: center;">
          <Btn
            btnText="支付完成"
            className="primary"
            :width="120"
            style="margin-top:30px"
            @handleClick="handlePayDone"
          />
        </div>
      </PayMember>
    </div>
  </div>
</template>

<script>
import { etcSave } from "@/api/report";
import PayMember from "../../../components/PayMember.vue";
import Btn from "@/components/Btn.vue";
import { getUserInfo } from "@/api/user";
import Back from "../../../components/Back.vue";
import { webSocketMixin } from "@/utils/mixins.js";
export default {
  mixins: [webSocketMixin],
  components: { PayMember, Btn, Back },
  data() {
    return {
      pickerOptions: {
        //禁用当前日期之前的日期
        disabledDate(time) {
          //Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      list: [
        {
          date: "2022-04-07 17:13",
          dataSource: "阿里巴巴",
          phone: "18988889999",
          status: "待处理"
        },
        {
          date: "2022-04-07 17:13",
          dataSource: "阿里巴巴",
          phone: "18988889999",
          status: "待处理"
        }
      ],
      report: JSON.parse(localStorage.getItem("report")),
      checkTimes: true,
      authDateLimit: true,
      checkTimes1: false,
      authDateLimit1: false,
      phone: "",
      authorizationUsers: [],
      form: {
        authorizationTimes: undefined,
        endDate: undefined,
        name: undefined,
        remark: undefined,
        reportId: JSON.parse(localStorage.getItem("report")).id,
        whiteList: undefined
      },
      dialagPay: false,
      isLimitTimes: "1",
      isLimitDate: "1",
      etcDefaultName: "",
      isLimitUser: "1"
    };
  },
  created() {
    const now = new Date();
    this.etcDefaultName =
      now.getFullYear() +
      "" +
      (now.getMonth() + 1 < 10
        ? "0" + (now.getMonth() + 1)
        : now.getMonth() + 1) +
      "" +
      (now.getDate() < 10 ? "0" + now.getDate() : now.getDate()) +
      "" +
      (now.getHours() < 10 ? "0" + now.getHours() : now.getHours()) +
      (now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes()) +
      (now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds());
  },
  methods: {
    handleDetail() {
      this.$router.push("credentialsDetail");
    },
    async getUser() {
      await getUserInfo().then(res => {
        sessionStorage.setItem("userInfo", JSON.stringify(res.data.d));
      });
    },
    handleCheckTimesChange() {
      delete this.form.authorizationTimes;
    },
    handleAuthDateLimit1Change() {
      delete this.form.endDate;
    },
    handleCreate() {
      let tempData = Object.assign({}, this.form);
      const { authorizationTimes, endDate, name, etcDefaultName } = this.form;
      // if (!name) {
      //   this.$message.error("电子证书名称不能为空");
      //   return false;
      // }
      if (this.isLimitTimes === "2") {
        if (!authorizationTimes) {
          this.$message.error("限制次数不能为空");
          return false;
        }
        let str = /^\d+$/;
        if (str.test(authorizationTimes)) {
          console.log(true);
        } else {
          this.$message.error("限制次数填写不正确");
          return false;
        }
      }
      if (this.isLimitDate === "2") {
        if (!endDate) {
          this.$message.error("限制时间不能为空");
          return false;
        }
      }
      const timestamp = 24 * 60 * 60 * 1000 - 1;
      tempData.endDate = Math.floor((this.form.endDate + timestamp) / 1000);
      // authorizationTimes: undefined,
      //   endDate: undefined,
      // if(isLimitTimes==='1'){
      //   delete tempData.authorizationTimes
      // }
      // if(isLimitDate==='1'){
      //   delete tempData.endDate
      // }
      if (!tempData.name) {
        tempData.name = this.etcDefaultName;
      }
      tempData.whiteList = this.authorizationUsers.toString();
      etcSave(tempData).then(res => {
        if (res.data.c == 501005) {
          this._initSocket();
          this._socket.onmessage = e => {
            let { data } = e;
            if (data) {
              data = JSON.parse(data);
              console.log(data);
              const { type, paySuccess, message } = data;
              if (type === 2 && paySuccess) {
                // this.handleResult()
                this.handlePayDone();
              }
            }
          };
          this.dialagPay = true;
        }
        if (res.data.c === 200) {
          this.dialogPay = false;
          this.$message.success("创建成功");
          this.getUser();
          this.$router.go(-1);
        }
      });
    },
    handlePayDone() {
      this.handleCreate();
    },
    handleDialagPayClose() {
      this.dialagPay = false;
    },
    handleLimitDateChange() {
      this.form.endDate = undefined;
      // delete this.form.endDate;
    },
    handleLimitTimesChange() {
      this.form.authorizationTimes = undefined;
      // delete this.form.authorizationTimes;
    },
    handleLimitUserChange() {
      this.form.whiteList = "";
    },
    savePhone() {
      if (!this.phone) {
        this.$message.error("请输入手机号");
        return;
      } else if (this.phone.length !== 11) {
        this.$message.error("手机号格式错误");
        return;
      }

      this.authorizationUsers.push(this.phone);
      this.phone = "";
    },
    handleDeletePhone(index) {
      this.authorizationUsers.splice(index, 1);
    }
  },
  watch: {
    isLimitUser: {
      handler(val) {
        // console.log(val);
        this.phone = "";
        this.authorizationUsers = [];
      }
    }
  }
};
</script>

<style scoped lang="scss">
.personalReport {
  display: flex;
  margin-top: 39px;
  flex: 1;
  margin-bottom: 70px;
  background: #fff;
  margin-left: 17px;
  padding: 38px 41px 60px 40px;
  flex-direction: column;
  min-height: 702px;
  box-sizing: border-box;
  // .el-table th.el-table__cell {
  //   background-color: #f0f2f5;
  // }
  .reportInfo {
    padding: 36px 45px;
    display: flex;
    background: #f0f2f5;
    border-radius: 2px;
    justify-content: space-between;
    line-height: 27px;
    font-size: 14px;
    margin-top: 11px;
    margin-bottom: 32px;
    color: #6e6e6e;
  }
  .title {
    margin-bottom: 22px;
    font-weight: bold;
  }
  .detail {
    color: #338ff7;
  }
  .btns {
    display: flex;
    align-items: center;
    .btn_primary {
      background: #3a61b1;
      color: #fff;
      border: 0;
      outline: none;
      width: 77.7px;
      border-radius: 15px;
      height: 30px;
    }
    .btn_primary_plain {
      color: #3a61b1;
      background: #f0f2f5;
      border: 1px solid #3a61b1;
      outline: none;
      width: 77.7px;
      border-radius: 15px;
      height: 30px;
    }
  }
  .btn_default {
    width: 126px;
    height: 39px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 20px;
  }
  .dataTable {
    margin-top: 33px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tabList {
      .tabItem {
        color: #6e6e6e;
        font-size: 16px;
        margin-right: 42px;
      }
      .active {
        color: #3a61b1;
      }
    }
  }
  .list {
    margin-top: 18px;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: #6e6e6e;
    .item {
      padding: 30px 32px 35px 34px;
      line-height: 29px;
      border: 1px solid #f1f1f1;
      margin-bottom: 19px;
      display: flex;
      justify-content: space-between;
      &:last-child {
        margin-bottom: 0;
      }
      .btns {
        color: #338ff7;
        flex-direction: column;
        span {
          cursor: pointer;
        }
      }
      .status {
        color: #ff5129;
      }
      .r16 {
        color: #ff5129;
        font-size: 16px;
      }
    }
  }
  .btn_add {
    width: 142px;
    height: 41px;
    background: #3a61b1;
    color: #fff;
    border-radius: 21px;
    border: 0;
    cursor: pointer;
  }
  .tagList {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 10px;
    .tagItem {
      background: #dee9ff;
      border: 1px solid #3a61b1;
      border-radius: 2px;
      width: 120px;
      height: 27px;
      // line-height: 27px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #3a61b1;
      padding-left: 9px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      margin-right: 10px;
      i {
        display: inline-block;
        background: url("../../../assets/icon_ctu_close.png") no-repeat;
        background-size: cover;
        width: 9px;
        height: 9px;
        cursor: pointer;
        margin-left: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/report/create.vue